/**
 * MÓDULOS Y PERMISOS — el vocabulario sale del contrato
 * =====================================================
 *
 * `@planilla/contratos` define qué módulos y qué permisos existen, y es el mismo paquete con el
 * que la API decide si te deja pasar. Si el front tuviera su propia lista, alcanzaría con
 * agregar un permiso en un lado para que el editor de roles quede mintiendo.
 *
 * EL MENÚ NO SE ESCRIBE ACÁ. Llega en `/auth/yo` como `menu[]`, que la API calcula como
 * permisos ∩ módulos del plan. Un archivo de menú paralelo en el front se desincroniza y termina
 * ofreciendo pantallas que responden 403.
 */
export {
  MODULOS,
  MODULOS_VENDIBLES,
  PERMISOS,
  TODOS_LOS_PERMISOS,
  calcularMenu,
  esPermisoValido,
  moduloDePermiso,
  modulosHabilitados,
} from '@planilla/contratos';
export type { ClaveModulo, ClavePermiso, DefinicionModulo, DefinicionPermiso, EntradaMenu } from '@planilla/contratos';

import { MODULOS, PERMISOS, TODOS_LOS_PERMISOS, type ClaveModulo, type DefinicionModulo, type DefinicionPermiso } from '@planilla/contratos';

export function moduloPorClave(clave: string): DefinicionModulo | undefined {
  return MODULOS.find((modulo) => modulo.clave === clave);
}

export function permisosDeModulo(modulo: ClaveModulo): DefinicionPermiso[] {
  return PERMISOS.filter((permiso) => permiso.modulo === modulo);
}

/**
 * Se acepta `string` y no solo `ClavePermiso` a propósito: los permisos que llegan en la sesión
 * son datos de la base, y un rol viejo puede tener una clave que ya no existe en el código.
 * Preguntar por ella tiene que devolver false, no romper.
 */
export function tienePermiso(permisos: readonly string[], requerido: string): boolean {
  return permisos.includes(TODOS_LOS_PERMISOS) || permisos.includes(requerido);
}

/** Para las guardas de ruta: alcanza con tener UNO de los permisos de la pantalla. */
export function tieneAlguno(permisos: readonly string[], requeridos: readonly string[]): boolean {
  return requeridos.some((permiso) => tienePermiso(permisos, permiso));
}
